import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'commonModalOracle',
  props: ['modalType', 'vendorCode', 'poNumber','erpOuId','tdsData','expnseType'],
  components: {},
  watch: {
    currentPageLegalEntity: function() {
      this.getbusinessData();
    },
    perPageLegalEntity: function() {
      this.currentPageLegalEntity = 1;
      this.getbusinessData();
    },
    currentPagePeriod: function() {
      this.getPeriodMonth();
    },
    perPagePeriod: function() {
      this.currentPagePeriod = 1;
      this.getPeriodMonth();
    },
    currentPageVendor: function() {
      this.getVendorDetails();
    },
    perPageVendor: function() {
      this.currentPageVendor = 1;
      this.getVendorDetails();
    },
    currentPagePoNumber: function() {
      this.getPoNumberDetails();
    },
    perPagePoNumber: function() {
      this.currentPagePoNumber = 1;
      this.getPoNumberDetails();
    },
    currentPageAccCode: function() {
      this.getAccCodeDetails();
    },
    perPageAccCode: function() {
      this.currentPageAccCode = 1;
      this.getAccCodeDetails();
    },
    currentPageTdsSection: function() {
      this.getTdsSectionDetail();
    },
    perPageTdsSection: function() {
      this.currentPageTdsSection = 1;
      this.getTdsSectionDetail();
    },
    currentPageVendorType: function() {
      this.getVendorType();
    },
    perPageVendorType: function() {
      this.currentPageVendorType = 1;
      this.getVendorType();
    },
    currentPageLiabilityAccount: function() {
      this.getLiabilityAccount();
    },
    perPageLiabilityAccount: function() {
      this.currentPageLiabilityAccount = 1;
      this.getLiabilityAccount();
    }
  },
  data() {
    return {
      // Common Variables
      loader: false,
      // Legal Entity Form Variables
      perPageLegalEntity: commonHelper.perPageRecord,
      pageOptionsLegalEntity: commonHelper.getPageOption(),
      totalRowsLegalEntity: null,
      currentPageLegalEntity: 1,
      businessData: [],
      businessFields: [
        {
          key: 'lookup_code'
        },
        {
          key: 'start_date_active'
        },
        {
          key: 'end_date_active'
        },
        {
          key: 'enabled_flag'
        },
      ],
      legalEntitySearch: null,
      // Period Form Variables
      perPagePeriod: commonHelper.perPageRecord,
      pageOptionsPeriod: commonHelper.getPageOption(),
      totalRowsPeriod: null,
      currentPagePeriod: 1,
      periodData: [],
      periodFields: [
        {
            key: 'lookup_code'
          },
          {
            key: 'start_date_active'
          },
          {
            key: 'end_date_active'
          },
          {
            key: 'enabled_flag'
          },
      ],
      periodSearch: null,
      // tdsSection Form Variables
      perPageTdsSection: commonHelper.perPageRecord,
      pageOptionsTdsSection: commonHelper.getPageOption(),
      totalRowsTdsSection: null,
      currentPageTdsSection: 1,
      tdsSectionData: [],
      tdsSectionFields: [
        {
            key: 'lookup_code'
          },
          {
            key: 'meaning',
            label: 'Lookup Meaning'
          },
      ],
      tdsSectionSearch: null,
      // Vendor Type Form Variables
      perPageVendorType: commonHelper.perPageRecord,
      pageOptionsVendorType: commonHelper.getPageOption(),
      totalRowsVendorType: null,
      currentPageVendorType: 1,
      vendorTypeData: [],
      vendorTypeFields: [
        {
            key: 'meaning',
            label: 'Vendor Type'
        },
          {
            key: 'lookup_code',
            // label: 'L'
          },
          // {
          //   key: 'PREPAYMENT_ACCT',
          //   label: 'Prepayment Account'
          // },
      ],
      vendorSearch: null,
      // Vendor Form Variables
      perPageVendor: commonHelper.perPageRecord,
      pageOptionsVendor: commonHelper.getPageOption(),
      totalRowsVendor: null,
      currentPageVendor: 1,
      vendorData: [],
      vendorFields: [
        {
          key: 'vendor_name'
        },
        {
          key: 'vendor_code'
        },
        {
          key: 'pan_number',
          label: 'PAN No.'
        }
      ],
      vendorNameSearch: '',
      vendorCodeSearch: '',
      vendorPanSearch: '',
      // PO Number Form Variables
      perPagePoNumber: commonHelper.perPageRecord,
      pageOptionsPoNumber: commonHelper.getPageOption(),
      totalRowsPoNumber: null,
      currentPagePoNumber: 1,
      poNumberData: [],
      poNumberFields: [
        {
          key: 'po_number',
          label: 'PO Number'
        },
        {
          key: 'po_currency',
          label: 'PO Currency'
        },
        {
          key: 'line_num',
          label: 'PO Line Number'
        },
        {
          key: 'item_description'
        }
      ],
      poNumberSearch: '',
      // Account Code Form Variables
      perPageAccCode: commonHelper.perPageRecord,
      pageOptionsAccCode: commonHelper.getPageOption(),
      totalRowsAccCode: null,
      currentPageAccCode: 1,
      accCodeData: [],
      accCodeFields: [
        {
          key: 'code_combination_segment',
          label: 'Account Code'
        }
      ],
      accCodeSearch: null,
      // Liability Account Form Variables
      perPageLiabilityAccount: commonHelper.perPageRecord,
      pageOptionsLiabilityAccount: commonHelper.getPageOption(),
      totalRowsLiabilityAccount: null,
      currentPageLiabilityAccount: 1,
      liabilityAccountData: [],
      liabilityAccountFields: [
        {
          key: 'account_code'
        },
        {
          key: 'project_code'
        },
        // 1.0 <Anuj> 
        {
          key: 'description'
        },
        {
          key: 'concatenated_segments'
        }
      ],
      liabilityAccountSearch: null,
      descriptionSearch: null    // 1.0 <Anuj> 
    };
  },
  // computed: {
  //   filteredbusinessData() {
  //     if (!this.legalEntitySearch) {
  //       return this.businessData;
  //     }
  //     const searchQuery = this.legalEntitySearch.toLowerCase();
  //     return this.businessData.filter(item =>
  //       item.le_name.toLowerCase().includes(searchQuery)
  //     );
  //   }
  // },
  mounted() {
    if (this.modalType === 'business_unit') {
      this.getBusinessUnitDetail();
    } else if (this.modalType === 'expense_type') {
      this.getExpenseTypeDetail();
    } else if (this.modalType === 'tdsSection') {
      this.getTdsSectionDetail();
    } else if (this.modalType === 'vendorType') {
      this.getVendorType();
    }
  },
  methods: {
    // Functions for Business Form
    getBusinessUnitDetail() {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getBusinessUnitDetail')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.businessData = result;
            this.totalRowsLegalEntity = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedBusiness(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearLegalEntity() {
      this.legalEntitySearch = null;
      this.getbusinessData();
    },
    // Functions for Expense Form
    getExpenseTypeDetail() {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getExpenseTypeDetail')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.periodData = result;
            this.totalRowsPeriod = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedPeriod(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearPeriod() {
      this.periodSearch = null;
      this.getPeriodMonth();
    },
    // Functions for TDS Section Form
    getTdsSectionDetail() {
      const payload = {
        _page: this.currentPageTdsSection - 1,
        _limit: this.perPageTdsSection,
        description: this.tdsSectionSearch,
        nature_of_supply:this.tdsData.nature_of_supply,
        country:this.tdsData.country
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getTdsSectionDetail', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.tdsSectionData = result;
            this.totalRowsTdsSection = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedTdsSection(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearTdsSection() {
      this.tdsSectionSearch = null;
      this.getTdsSectionDetail();
    },
    // Functions for Vendor Type Form
    // getVendorType() {
    //   const payload = {
    //     // _page: this.currentPageVendorType - 1,
    //     // _limit: this.perPageVendorType,
    //     erp_ou_id:this.erpOuId,
    //     description: this.vendorSearch,
    //     expense_type:this.expnseType
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('intWorkflow/getVendorType', payload)
    //     .then(resp => {
    //       this.loader = false;
    //       if (resp.status === 200) {
    //         const result = resp.data.data;
    //         this.vendorTypeData = result;
    //         this.totalRowsVendorType = resp.data.data.total_elements;
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    getVendorType() {
      const payload = {
        _page: this.currentPageVendorType - 1,
        _limit: this.perPageVendorType,
        // erp_ou_id:this.erpOuId,
        description: this.vendorSearch,
        // expense_type:this.expnseType
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getVendorTypeforVatika', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.vendorTypeData = result;
            this.totalRowsVendorType = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedVendorType(item) {
      this.$emit('mapSelectedVsetData', item);
    },
    clearVendorType() {
      this.vendorSearch = null;
      this.getVendorType();
    },

    // Liability Account Form
    getLiabilityAccount() {
      const payload = {
        _page: this.currentPageLiabilityAccount - 1,
        _limit: this.perPageLiabilityAccount,
        concatenated_segments: this.liabilityAccountSearch,
        description: this.descriptionSearch     // 1.0 <Anuj> 
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getLiabilityAccount', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.liabilityAccountData = result;
            this.totalRowsLiabilityAccount = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedLiabilityAccount(item){
      let rowData = item
      rowData.formName = this.modalType
      this.$emit('mapSelectedVsetData', rowData);
    },
    clearLiabilityAccount(){
      this.liabilityAccountSearch = null;
      this.descriptionSearch = null;   // 1.0 <Anuj> 
    },
    // Common Functions
    clearVsetValues(vsetCode) {
      if (vsetCode === this.legalEntitySearch) {
        this.legalEntitySearch = null;
      } else if (vsetCode === this.periodSearch) {
        this.periodSearch = null;
      } else if (vsetCode === this.vendorNameSearch) {
        this.vendorNameSearch = null;
      } else if (vsetCode === this.vendorCodeSearch) {
        this.vendorCodeSearch = null;
      } else if (vsetCode === this.poNumberSearch) {
        this.poNumberSearch = '';
      } else if (vsetCode === this.accCodeSearch) {
        this.accCodeSearch = null;
      } else if (vsetCode === this.tdsSectionSearch) {
        this.tdsSectionSearch = null;
      } else if (vsetCode === this.liabilityAccountSearch) {
        this.liabilityAccountSearch = null;
      } else if (vsetCode === this.descriptionSearch) {
        // 1.0 <Anuj> 
        this.descriptionSearch = null;
      }
    }
  }
};


